import {useTranslation} from 'react-i18next';
import ContentCardV4 from '../../../common/component/ContentCardV4';
import HorizontalList from '../../../common/component/HorizontalList';
import Text from '../../../common/component/Text';
import {Page} from '../../../common/constant/page';
import useScreenType from '../../../common/hook/useScreenType';
import {routeTo} from '../../../common/util/PageRouter';
import {IRecommendItemContent} from '../../../commonSub/type';

interface IProps {
  contents: IRecommendItemContent[];
  sendClickEvent: (content: IRecommendItemContent, index: number) => void;
  sendViewImp: (content: IRecommendItemContent, index: number) => void;
}

export default function RecommendContents({
  contents: _contents,
  sendClickEvent,
  sendViewImp,
}: IProps) {
  const {t} = useTranslation();

  const onClickContent = (content: IRecommendItemContent, index: number) => {
    sendClickEvent(content, index);
    routeTo({page: Page.Content, id: content.id, sid: content.sid});
  };

  const {isMedium, isLarge} = useScreenType();
  const contents =
    isMedium || isLarge ? _contents.slice(0, isMedium ? 4 : 5) : _contents;

  return (
    <div className="pb-20 mt-30">
      <Text className="mb-12 ml-10 s16-bold-white light:text-black">
        {t('viewer_end_recommendation_v4')}
      </Text>
      <HorizontalList
        items={contents}
        itemWrapperClassName="overflow-hidden w-[115px] md:w-[114px] lg:w-[118px]"
      >
        {(content, index) => (
          <ContentCardV4
            content={content}
            onClick={() => onClickContent(content, index)}
            onIntersection={isIntersecting =>
              isIntersecting && sendViewImp(content, index)
            }
          />
        )}
      </HorizontalList>
    </div>
  );
}
